const selectData = (state) => state.settings.emailServer.gsuite.data
const selectLoader = (state) => state.settings.emailServer.gsuite.loader
const selectError = (state) => state.settings.emailServer.gsuite.error

export { selectData, selectLoader, selectError }
